// 追梦中国相关页面
export const ROUTE_NAME = {
    GAME_RANK: 'GAME_RANK',
};

export function getGameImg(name: string) {
    return require(`@/assets/images/game/${name}`);
}
